export const AUTH_OTP_SUCCESS = "auth/AUTH_OTP_SUCCESS";
export const AUTH_OTP_FAILURE = "auth/AUTH_OTP_FAILURE";
export const AUTH_LOGIN_SUCCESS = "auth/AUTH_LOGIN_SUCCESS";
export const AUTH_LOGIN_FAILURE = "auth/AUTH_LOGIN_FAILURE";
export const AUTH_GET_USER_DETAIL_SUCCESS = "auth/AUTH_GET_USER_DETAIL_SUCCESS";
export const AUTH_GET_USER_DETAIL_FAILURE = "auth/AUTH_GET_USER_DETAIL_FAILURE";
export const ALL_USERS_SUCCESS = "auth/ALL_USERS_SUCCESS";
export const ALL_USERS_FAILURE = "auth/ALL_USERS_FAILURE";
export const ALL_USERS_OPEN_SUCCESS = "auth/ALL_USERS_OPEN_SUCCESS";
export const ALL_USERS_OPEN_FAILURE = "auth/ALL_USERS_OPEN_FAILURE";